import ChipColors from './ChipColors';

export default [
  {
    text: 'Pendente',
    value: 'Pending',
    ...ChipColors.wait,
  },
  {
    text: 'Finalizado',
    value: 'Completed',
    ...ChipColors.success,
  },
  {
    text: 'Cancelado',
    value: 'Canceled',
    ...ChipColors.danger,
  },
  {
    text: 'Estornada',
    value: 'Desfazimento',
    ...ChipColors.neutral,
  },
];
